import { Injectable } from '@angular/core';
import { AuthService, CommandService, Country, EventService, LanguageSetEvent, Query, QueryService, SiteConnector, UserIdService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { UserProfileService } from '@spartacus/user/profile/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DocumentIdentifierType, JobType, UserTaxGroup } from 'src/app/spartacus/spartacus-custom.module';
import { CustomUserProfileConnector } from '../../custom-register/store/conectors/custom-user-profile.connector';
import { CustomUserProfileFacade } from './custom-user-profile.facade';

@Injectable({
  providedIn: 'root',
})
export class CustomUserProfileService extends UserProfileService implements CustomUserProfileFacade {

  constructor(
    protected userAccountService: UserAccountFacade,
    protected authService: AuthService,
    protected userProfileConnector: CustomUserProfileConnector,
    protected siteConnector: SiteConnector,
    protected eventService: EventService,
    protected userIdService: UserIdService,
    protected query: QueryService,
    protected command: CommandService
  ) {
    super(userAccountService, authService, userProfileConnector, eventService, userIdService, query, command);
  }

  protected countryQuery: Query<Country[]> = this.query.create(
    () => this.siteConnector.getCountries(),
    {
      reloadOn: [LanguageSetEvent],
    }
  );

  getCountries(): Observable<Country[]> {
    return this.countryQuery.get().pipe(map((countries) => countries ?? []));
  }

  protected jobTypeQuery: Query<JobType[]> = this.query.create(
    () => this.userProfileConnector.getJobTypes(),
    {
      reloadOn: [LanguageSetEvent],
    }
  );

  getJobTypes(): Observable<JobType[]> {
    return this.jobTypeQuery.get().pipe(map((jobTypes) => jobTypes ?? []));
  }

  protected userTaxGroupQuery: Query<UserTaxGroup[]> = this.query.create(
    () => this.userProfileConnector.getUserTaxGroups(),
    {
      reloadOn: [LanguageSetEvent],
    }
  );

  getUserTaxGroups(): Observable<UserTaxGroup[]> {
    return this.userTaxGroupQuery.get().pipe(map((userTaxGroups) => userTaxGroups ?? []));
  }
  protected documentIdentifierTypeQuery: Query<DocumentIdentifierType[]> = this.query.create(
    () => this.userProfileConnector.getDocumentIdentifierTypes(),
    {
      reloadOn: [LanguageSetEvent],
    }
  );

  getDocumentIdentifierTypes(): Observable<DocumentIdentifierType[]> {
    return this.documentIdentifierTypeQuery.get().pipe(map((documentIdentifierTypes) => documentIdentifierTypes ?? []));
  }
}
